import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import { store } from "./store";
import "./plugins/vee-validate";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import { apolloProvider } from "./graphql/apollo";
import VueHead from "vue-head";
import "vue2-timepicker/dist/VueTimepicker.css";
import VuePlyr from "vue-plyr";
import filters from "./filters";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import Toasted from "vue-toasted";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import HighchartsVue from "highcharts-vue";
import JsonCSV from "vue-json-csv";
import ScrollLoader from "vue-scroll-loader";
import VueAgile from "vue-agile";
import Cloudinary, { CldImage, CldVideo, CldTransformation, CldContext } from "cloudinary-vue";

Vue.prototype.$appApiEndPoint = process.env.VUE_APP_API_ENDPOINT;
Vue.prototype.$appEndPoint = process.env.VUE_APP_ENDPOINT;

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENVIRONMENT,
  integrations: process.env.NODE_ENV === "production" ? [new Integrations.Vue({ Vue, attachProps: true })] : [],
});

Sentry.configureScope(function(scope) {
  scope.setUser(JSON.parse(localStorage.getItem("user")) || store.getters.user);
});

Vue.use(ScrollLoader);
Vue.use(VueAgile);
Vue.config.productionTip = false;
Vue.use(VueMoment, {
  moment,
});

Vue.use(Cloudinary, {
  configuration: { cloudName: "jeff-fitness" },
  components: {
    CldContext,
    CldImage,
    CldVideo,
    CldTransformation,
  },
});

Vue.use(VueHead);
Vue.use(HighchartsVue);
Vue.component("downloadCsv", JsonCSV);

Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: true },
  },
  emit: ["ended"],
});

Vue.prototype.$super = function(options) {
  return new Proxy(options, {
    get: (options, name) => {
    	if(options.methods && name in options.methods) {
      	return options.methods[name].bind(this);
      }
    },
  });
};

Vue.use(Toasted, {
  position: "top-right",
  duration: 6000,
  keepOnHover: true,
  iconPack: "mdi",
  router,
});

Vue.use(VueTelInput);

/**
 * Bind filters to the main vue instance
 */
for (var key in filters) {
  Vue.filter(key, filters[key]);
}

new Vue({
  render: (h) => h(App),
  apolloProvider,
  router,
  store,
  vuetify,
}).$mount("#app");
